var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols-md":"4","label":"出金時振込先口座"}},[_c('div',{staticClass:"form-control-plaintext"},[_vm._v(" "+_vm._s(_vm.bankName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }